
import GbHeader from '@geekbrains/geekbrains-ui-kit/src/elements/Header/Header.vue'
import GbFooter from '@geekbrains/geekbrains-ui-kit/src/elements/Footer/Footer.vue'
import { createNamespacedHelpers } from 'vuex'
import { getCookie } from '~/utils/helpers'
const { mapState } = createNamespacedHelpers('header')

export default {
  name: 'WithoutBanners',
  components: {
    GbHeader,
    GbFooter
  },

  data() {
    return {
      footerData: [{ children: [] }],
      isAuth: false,
      userInfo: null
    }
  },

  async fetch() {
    const jwtToken = getCookie(
      'jwt_token',
      this.$ssrContext?.req?.headers.cookie
    )

    const Authorization = jwtToken ? `Bearer ${jwtToken}` : null

    this.$store.commit('user/set', { type: 'jwtToken', payload: Authorization })
    this.isAuth = !!jwtToken

    try {
      await this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'profile',
          'line_second'
        ]
      })

      const { data: footer = [] } =
        await this.$repositories.navigation.getMenuListByType(
          'main',
          Authorization,
          this.$route.fullPath,
          'footer'
        )

      this.footerData = footer[0].items
    } catch (e) {
      console.error('Layout -> WithoutBanners.vue: ', e)
    }
  },

  computed: {
    ...mapState(['currentHeaderData'])
  },

  watch: {
    $route() {
      document.querySelector('#usedesk-messenger')?.remove()
      document.querySelector('#fasttrack-MainFrame')?.remove()
      document.querySelector('#fasttrack-InviteFrame')?.remove()

      this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'line_second'
        ]
      })
    }
  },

  beforeMount() {
    const jwtToken = getCookie('jwt_token')
    const Authorization = jwtToken ? `Bearer ${jwtToken}` : null

    this.isAuth = !!jwtToken
    this.$store.commit('user/set', { type: 'jwtToken', payload: Authorization })
  },

  async mounted() {
    const Authorization = this.$store.state.user.jwtToken
    let userInfo = {}
    try {
      ;[
        {
          value: { data: userInfo = {} }
        }
      ] = await Promise.allSettled([
        this.isAuth && this.$repositories.users.getUserInfo()
      ])

      if (userInfo) {
        this.userInfo = userInfo
      }
    } catch (e) {
      console.error(e)
    }

    try {
      await this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'profile',
          'line_second',
          'button'
        ],
        forced: true
      })

      const { data: footer = [] } =
        await this.$repositories.navigation.getMenuListByType(
          'main',
          Authorization,
          this.$route.fullPath,
          'footer'
        )

      this.footerData = footer[0].items
    } catch (e) {
      console.error('Layout -> WithoutBanners.vue: ', e)
    }
  }
}
